module.exports = __webpack_public_path__ + "img/user-zj-avatar.dc6482f3.png";